define("shared/components/shared-carousel/carousel-controls", ["exports", "@ember/component", "@ember/template-factory", "@glimmer/component"], function (_exports, _component, _templateFactory, _component2) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"@glimmer/component",0,"@ember/template-factory"eaimeta@70e063a35619d71f

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div ...attributes>
    {{#if canGoLeft}}
      <a role="button" onclick={{action @updateIndex -1}}>
        <span class="cCP--slide__prev">
          {{svg-jar "nav-left" class="o--icon o--icon--white"}}
        </span>
      </a>
    {{/if}}
  
    {{#if canGoRight}}
      <a role="button" onclick={{action @updateIndex 1}}>
        <span class="cCP--slide__next">
          {{svg-jar "nav-right" class="o--icon o--icon--white"}}
        </span>
      </a>
    {{/if}}
  </div>
  
  */
  {
    "id": "NhD9e7IR",
    "block": "[[[11,0],[17,1],[12],[1,\"\\n\"],[41,[33,1],[[[1,\"    \"],[10,3],[14,\"role\",\"button\"],[15,\"onclick\",[28,[37,2],[[30,0],[30,2],-1],null]],[12],[1,\"\\n      \"],[10,1],[14,0,\"cCP--slide__prev\"],[12],[1,\"\\n        \"],[1,[28,[35,3],[\"nav-left\"],[[\"class\"],[\"o--icon o--icon--white\"]]]],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[33,4],[[[1,\"    \"],[10,3],[14,\"role\",\"button\"],[15,\"onclick\",[28,[37,2],[[30,0],[30,2],1],null]],[12],[1,\"\\n      \"],[10,1],[14,0,\"cCP--slide__next\"],[12],[1,\"\\n        \"],[1,[28,[35,3],[\"nav-right\"],[[\"class\"],[\"o--icon o--icon--white\"]]]],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]],null],[13],[1,\"\\n\"]],[\"&attrs\",\"@updateIndex\"],false,[\"if\",\"canGoLeft\",\"action\",\"svg-jar\",\"canGoRight\"]]",
    "moduleName": "shared/components/shared-carousel/carousel-controls.hbs",
    "isStrictMode": false
  });

  class CarouselControls extends _component2.default {
    get canGoLeft() {
      return this.args.index > 0;
    }

    get canGoRight() {
      const items = this.args.carouselMediaItems;
      return this.args.index < items.length - 1;
    }

  }

  _exports.default = CarouselControls;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, CarouselControls);
});